import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';
import AvivaReferral from './components/pages/AvivaReferral';
import { ScrollToTop } from '@percihealth/react';
import {
  ReferredPage,
  SignedInLayout,
} from '@packages/web-shared/components/referrals';
import {
  AskForRightsPage,
  AuthProvider,
  PrivateElement,
} from '@percihealth/react-auth';
import DescopeLogin from '@packages/web-shared/components/auth/DescopeLogin';
import DescopeSessionProvider from '@packages/web-shared/components/auth/DescopeSessionProvider';
import firebaseApp from './firebase';
import { ClinicalAppPermission } from '@packages/core-shared';
import { FirebaseProvider } from '@packages/web-shared';

export default function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={
          <SignedInLayout>
            <ScrollToTop />
            <Outlet />
          </SignedInLayout>
        }
      >
        <Route
          path="/"
          element={
            <PrivateElement permission={ClinicalAppPermission.CrmReferrer}>
              <AvivaReferral />
            </PrivateElement>
          }
        />
        <Route
          path="referred"
          element={
            <PrivateElement permission={ClinicalAppPermission.CrmReferrer}>
              <ReferredPage />
            </PrivateElement>
          }
        />
        <Route path="/login" element={<DescopeLogin />} />
        <Route path="/ask-for-rights" element={<AskForRightsPage />} />
      </Route>,
    ),
  );

  return (
    <DescopeSessionProvider firebaseApp={firebaseApp}>
      <AuthProvider firebaseApp={firebaseApp}>
        <FirebaseProvider firebaseApp={firebaseApp}>
          <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
        </FirebaseProvider>
      </AuthProvider>
    </DescopeSessionProvider>
  );
}
